import { IconGridLayerSpecification } from '../chart-props';
import { RasterDrawFunction } from './type';

export const drawIconGridLayer: RasterDrawFunction<IconGridLayerSpecification> = (pass, source, layer, xAxis, yAxis) => {
    // Add padding to top and bottom equal to spacing Y
    // Take the remaining space and adjust vertical spacing to spread icons evenly
    const availableHeight = pass.viewState.chartArea.height - 2 * layer.iconSpacing[1];
    const ny = Math.floor((availableHeight + layer.iconSpacing[1]) / (layer.iconSize[1] + layer.iconSpacing[1]));
    // Check for ny <= 1 to avoid divide by 0
    const adjustedSpacingY = ny <= 1 ? layer.iconSpacing[1] : (availableHeight - ny * layer.iconSize[1]) / (ny - 1);

    const stepPixelsX = layer.iconSize[0] + layer.iconSpacing[0];
    const stepPixelsY = layer.iconSize[1] + adjustedSpacingY;

    const xAxisStart =
        pass.viewState.chartArea.left +
        Math.floor((pass.viewState.chartViewport.left - pass.viewState.chartArea.left) / stepPixelsX) * stepPixelsX +
        layer.iconSpacing[0] +
        layer.iconSize[0] * 0.5;

    const yAxisStart =
        pass.viewState.chartArea.top +
        Math.floor((pass.viewState.chartViewport.top - pass.viewState.chartArea.top) / stepPixelsY) * stepPixelsY +
        layer.iconSpacing[1] +
        layer.iconSize[1] * 0.5;

    const xAxisMax = Math.min(pass.viewState.chartViewport.right, pass.viewState.chartArea.right) + layer.iconSize[0] * 0.5;
    const yAxisMax = Math.min(pass.viewState.chartViewport.bottom, pass.viewState.chartArea.bottom) + layer.iconSize[1] * 0.5;

    for (let x = xAxisStart; x < xAxisMax; x += stepPixelsX) {
        for (let y = yAxisStart; y < yAxisMax; y += stepPixelsY) {
            const xx = xAxis.unproject(x, pass.viewState);
            const yy = yAxis.unproject(y, pass.viewState);

            const value = source.getValue(xx, yy);
            if (!value) {
                continue;
            }

            const icon = layer.getIcon(value);

            pass.drawer.drawSprite(layer.sprite, icon.x, icon.y, icon.w, icon.h, x, y, layer.iconSize[0], layer.iconSize[1], value[1] + 90);
        }
    }
};
